module.exports = __webpack_public_path__ + "static/media/Avatar_YouTube-Naranja.0d73e31f.jpg";